import { render, staticRenderFns } from "./_tag_color_picker.vue?vue&type=template&id=9c2045e4&scoped=true&"
import script from "./_tag_color_picker.vue?vue&type=script&lang=js&"
export * from "./_tag_color_picker.vue?vue&type=script&lang=js&"
import style0 from "./_tag_color_picker.vue?vue&type=style&index=0&id=9c2045e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2045e4",
  null
  
)

export default component.exports